// UI
import { DialogWrapper } from "@/components/dialogs/DialogWrapper"

// Icons
import { XIcon } from "@/lib/icons"

/**
 * ProjectTypeCrowdfunding
 * @returns
 */
export function ProjectTypeCrowdfunding({ onClose }: { onClose: () => void }) {
	return (
		<DialogWrapper>
			<div className="flex items-start justify-between rounded-t border-b p-5 dark:border-gray-600">
				<h3 className="text-xl font-semibold text-gray-900 dark:text-white lg:text-2xl">
					Crowdfunding
				</h3>
				<button
					onClick={() => onClose()}
					type="button"
					className="ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white"
					data-modal-toggle="default-modal"
				>
					<XIcon width={24} className="text-2xl text-gray-400" />
				</button>
			</div>

			<div className="space-y-6 p-6">
				<p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
					Zonhub Crowdfunding maakt investeren in duurzame energie
					voor iedereen mogelijk. Het platform bied een uitgebreide
					lijst aan projecten met verschillende soorten rente.
				</p>
				<ul className="ml-0 list-disc whitespace-pre-wrap text-gray-500">
					<li>
						Zo worden ZonneDelen uitbetaald op basis van de actuele
						productie en kun je ook live de productie bekijken,
					</li>
					<li>bieden Portfolio projecten een vaste rente</li>
					<li>
						En met Pro projecten beleg je tegen een vaste rente in
						meerdere projecten tegelijk.
					</li>
				</ul>
			</div>
		</DialogWrapper>
	)
}
